import styled from 'styled-components';

export const Container = styled.div``;

export const Imagem = styled.img`
  top: 0;
  left: 0;
  width: 100%;
  /* height: 100%; */
`;

export const Titulo = styled.h1`
  display: flex;
  font-size: calc(14px + 1vw);
  font-weight: bold;
  align-items: center;
  justify-content: center;
  margin: 15px;
`;

export const Descricao = styled.h1``;

export const Texto = styled.p`
  display: flex;
  justify-content: stretch;
  align-self: stretch;
  margin: 15px 30px;
  font-size: calc(10px + 1vw);
`;

export const Mensagem = styled.h1``;
